<script>
import { Radar } from 'vue-chartjs/legacy'
export default {
  extends: Radar,
  props: ['datasets','chartData'],
  data () {
    return {
      options: {
        plugins: {
          legend: {
            display: false
          }
        },
        scale: {
          angleLines: {
            lineWidth: 0.5,
          },
          pointLabels: {
            fontColor: 'black',
            fontSize: 18,
            fontStyle: 'bold',
          },
          ticks: {
            suggestedMin: 0,
            suggestedMax: 100,
            stepSize: 10,
            maxTicksLimit: 11,
            display: false, // remove label text only,
          }
        }
      }
    }
  },
  mounted() {
    Chart.defaults.global.legend.display = false;
    this.renderChart(this.datasets, this.options)
    this.htmlLegend = this.generateLegend()
  }
}
</script>